import { Banner } from '@ingenico/react-ui/banner';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import type { DeviceChangeDetailsProps } from './DeviceChangeDetails.model';
import styles from './DeviceChangeDetails.module.scss';

export function DeviceChangeDetails({
  subTitle,
  info,
  errorMessage,
  error,
  severity,
}: DeviceChangeDetailsProps): ReactNode {
  return (
    <div className={styles.deviceChangeDetailsContainer}>
      <Banner severity={severity ?? 'Error'} title={subTitle} message={error ?? errorMessage ?? toString(info)} />
    </div>
  );
}
